import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SpecSettingsProvider } from './contexts/SpecSettingsContext';
import { AnnaWall } from './pages/AnnaWall';
import { SpecStyle } from './pages/SpecStyle';
import { CommandCenter } from './pages/CommandCenter';
import { Logboek } from './pages/beheer/Logboek';
import { Huis } from './pages/beheer/Huis';
import { Systeem } from './pages/beheer/Systeem';
interface AppProps {
  /** Signature accent proposal: luminous teal or warm gold */
  accent?: 'teal' | 'gold';
  /** How expressive Anna's micro-behaviours are: gaze, blinks, sighs, perk-ups */
  aliveness?: 'calm' | 'lively';
}
export function App({
  accent = 'teal',
  aliveness = 'lively'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2whxabqim5ie4">
      <SpecSettingsProvider accent={accent} aliveness={aliveness} data-id="element-1" data-mp="28ufmg62gz4gf">
        <Routes data-id="element-2" data-mp="28sl5t3y8dyi5">
          <Route path="/" element={<AnnaWall data-id="element-4" data-mp="23vuokdaowwv5" />} data-id="element-3" data-mp="28s2ynca15zvg" />
          <Route path="/bureau" element={<CommandCenter data-id="element-6" data-mp="23v2u55stx56g" />} data-id="element-5" data-mp="23u9q4cl98ts0" />
          <Route path="/spec" element={<SpecStyle data-id="element-8" data-mp="3iiwdijzxza14" />} data-id="element-7" data-mp="3ik7gihlkcdr6" />
          <Route path="/beheer" element={<Navigate to="/beheer/logboek" replace data-id="element-10" data-mp="3ii4ppvcl6gle" />} data-id="element-9" data-mp="3ijfthv617oci" />
          <Route path="/beheer/logboek" element={<Logboek data-id="element-12" data-mp="3mj6jvxrnc2gi" />} data-id="element-11" data-mp="3mk85gw6ag7ch" />
          <Route path="/beheer/huis" element={<Huis data-id="element-14" data-mp="3rdkh85pvcjnt" />} data-id="element-13" data-mp="3rbr9en3irte8" />
          <Route path="/beheer/systeem" element={<Systeem data-id="element-16" data-mp="5opiv1o0k3w" />} data-id="element-15" data-mp="3rd17vdeab3le" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-18" data-mp="5gbgztt38r4" />} data-id="element-17" data-mp="4wxfu7a14id" />
        </Routes>
      </SpecSettingsProvider>
    </BrowserRouter>;
}